export default {
	// user: {
	// 	1: "Christoph",
	// 	2: "Tine",
	// 	3: "Tina",
	// 	4: "Henning",
	// 	5: "Moritz",
	// 	6: "Yves",
	// 	7: "Sydney",
	// 	8: "Yves",
	// 	9: "Isabelle",
	// 	10: "Ruben",
	// },

	users: {
		permissions: {
			// Lieferung bei Warnung (VA)
			delivery_va_with_errors: {
				1: true, //"Christoph",
				2: true, //"Tine",
				3: false, //"Tina",
				4: false, //"Henning",
				5: true, //"Moritz",
				6: false, //"Yves",
				7: false, //"Sydney",
				8: false, //"Alex",
				9: false, //"Isabelle",
				10: false, //"Ruben",
			},
			delivery_va_without_errors: {
				1: true, //"Christoph",
				2: true, //"Tine",
				3: true, //"Tina",
				4: false, //"Henning",
				5: true, //"Moritz",
				6: false, //"Yves",
				7: false, //"Sydney",
				8: false, //"Alex",
				9: false, //"Isabelle",
				10: false, //"Ruben",
			},
			delivery_ba_with_errors: {
				1: true, //"Christoph",
				2: true, //"Tine",
				3: false, //"Tina",
				4: false, //"Henning",
				5: true, //"Moritz",
				6: false, //"Yves",
				7: false, //"Sydney",
				8: false, //"Alex",
				9: false, //"Isabelle",
				10: false, //"Ruben",
			},
			delivery_ba_without_errors: {
				1: true, //"Christoph",
				2: true, //"Tine",
				3: false, //"Tina",
				4: false, //"Henning",
				5: true, //"Moritz",
				6: false, //"Yves",
				7: false, //"Sydney",
				8: false, //"Alex",
				9: false, //"Isabelle",
				10: false, //"Ruben",
			},
		},
	},

	customer_review: {
		review_status: {
			title: 'Auftragsprüfung',
			values: {
				1: "👀 Vorprüfung ausstehend ",
				3: "🔄 Änderung des 2. Prüfers angefordert",
				9: "✅ Vorprüfung abgeschlossen ",
			},
		},
	},
	customer_notes: {
		note_type: {
			title: 'Type',
			values: {
				1: "Notiz",
				2: "Telefoniert",
				3: "WhatsApp",
				// 4: "E-Mail",
				// 5: "Sonstiges",
				51: "Systemnachricht",
				52: "Fehlermeldung",
			},
		},
		system_message_id: {
			title: 'Systemnachricht',
			values: {
				1: "Der Auftrag wurde pausiert",
				2: "Der Auftrag wurde wieder freigeschaltet",
				3: "Der Energieausweis wurde nicht geliefert, da die Adresse nicht in dem Dokument gefunden wurde",
				4: "Automatische Lieferung wegen Ticketerstellung gestoppt.",
				5: "Der Auftrag wurde automatisch pausiert, da die E-Mail nicht zugestellt werden konnten.",
				6: "Die Envisys-Datei wurde nicht gefunden. Auftrag kann nicht geliefert werden.",
				7: "Der Auftrag wurde automatisch pausiert, da die Versanddatei nicht die korrekte Adresse enthält.",
				8: "Fehler in DIBt-Kontrolldatei. Manuelle Prüfung notwendig.",
				9: "DIBt-Kontrolldatei erfolgreich hochgeladen.",
				10: "Lieferdatum wegen Weihnachten verschoben",
				11: "Manuelle Erstattung über Mollie notw, da keine automatische Erstattung möglich war.",
				12: "Der Auftrag wurde aus einem anderen Auftrag dupliziert.",
				13: "Es ist kein DIBt-Kontingent mehr verfügbar. Bitte neues Kontingent kaufen.",
				14: "Der Brief wurde an LetterXpress für den Versand übergeben.",
				15: "Der Auftrag wurde gebucht.",
				16: "Der Auftrag wurde geliefert.",
				17: "Der Auftrag wurde storniert.",
				18: "Es wurde eine Zahlungserinnerung versendet.",
				19: "Der Auftrag wurde in die 1. Mahnstufe überführt.",
				20: "Der Auftrag wurde in die 2. Mahnstufe überführt.",
				21: "Es wurde eine Gutschrift erstellt.",
				22: "Rechnung erstellt.",
				23: "Zahlung eingegangen",
				24: "Auftragsvorphase abgeschlossen",
				25: "Änderung des 2. Prüfers angefordert",
				26: "Energieausweis wurde bei der DIBt registriert.",
				27: "Neues Ticket erstellt.",
				28: "Neue Ticketantwort erstellt.",
				29: "Der Auftrag wurde erstellt.",
				30: "Die Zahlung wurde vom Kunden zurückgebucht (Chargeback).",
				31: "Die Zahlung wurde nach Erinnerung beglichen.",
				32: "Es gab einen Fehler bei der Zahlung. Bitte manuell prüfen.",
			},
		},
	},

	customer_dibt: {
		used_software_id: {
			title: "Verwendete Software",
			values: {
				1: "Immobilienwerker v2",
				2: "Envisys",
			},
		},
		dibt_control_level: {
			title: 'DIBT-Kontrollstufe',
			values: {
				1: "keine Prüfstufe",
				2: "1. Prüfstufe (Kontrolldatei)",
				3: "2. Prüfstufe",
				4: "3. Prüfstufe",
			},
		},
		dibt_control_file_envisys: {
			title: 'Kontrolldatei (Envisys)',
		},
		dibt_control_file_submission: {
			title: 'Kontrolldatei (einreichte Kontrolldatei)',
		},
		dibt_control_file_current: {
			title: 'Kontrolldatei (aktuell)',
		},
	},
	freshdesk: {
		order_by: {
			"status": "Priorität",
			"created_at": "Erstellt am",
			"due_by": "Fällig am",
			"updated_at": "Geändert am",
		},
		order_type: {
			"asc": "Aufsteigend",
			"desc": "Absteigend",
		},
		status: {
			2: 'Offen',
			3: 'Ausstehend',
			4: 'Gelöst',
			5: 'Geschlossen',
			'': 'kein Filter',
		},
	},

	customer: {
		project: {
			title: 'Projekt',
			values: {
				'': '-',
				1: 'immobilienwerker.de',
				2: 'energieausweis-erstellen-online.de',
				3: 'energieausweis-haus_com',
			},
		},

		legal_version: {
			"GEG-2020": "GEG-2020",
			"GEG-2024": "GEG-2024",
		},
	},

	prompts: {
		call_status: {
			1: "Warte auf Ausführung",
			2: "In Ausführung",
			3: "Ausgeführt",
			9: "Fehler",
		},

		transaction_usefulness: {
			1: "Sehr nützlich",
			3: "Teilweise nützlich",
			9: "Nicht nützlich",
			11: "Funktioniert",
			12: "Überarbeitung notwendig",
		},

		models: {
			1: 'gpt-4',
			2: 'gpt-3.5-turbo-16k',
			3: 'gpt-4-turbo',
		},
	},
	tickets: {
		priority: {
			4: "Sehr dringend",
			3: "Dringend",
			2: "Normal",
			1: "Nicht dringend",
			'': "-",
		},
	},
	posts: {
		type: {
			1: "Blog-Post",
			2: "Textabschnitt",
			3: "Support-Vorlage",
			4: "Entwurf von Antwort",
		},
		is_published: {
			1: "Veröffentlicht", 2: "Privat", 3: "Nicht veröffentlicht",
		},
		project: {
			1: "immobilienwerker.de", 2: "energieausweis-erstellen-online.de", 3: "energieausweis-haus.com",
		},
		status: {
			2: 'Offen',
			3: 'Ausstehend',
			4: 'Gelöst',
			5: 'Geschlossen',
			'': '-',
		},
		priority: {
			1: "Nicht dringend",
			2: "Normal",
			3: "Dringend",
			4: "Sehr dringend",
		},
		group_id: {
			103000051926: "Rückfragen zu Auftrag",
			103000342481: "Support",
			// 103000342482: "[energieausweis-haus.com] Support",
			// 103000342552: "[immobilienwerker.de] Support",
		},
	},

};
